<template>
  <section class="page-header">
    <div class="ds-container">
      <div class="page-header__grid ds-grid">
        <div class="ds-grid__col ds-grid__col--12 ds-lg-grid__col--6 ds-margin-top-48">
          <HeaderSubpage
            :navigation-data="headerContent.link"
            :title="headerContent.title"
            :rich-text="headerContent.description"
          />

          <PaymentMethodPricing v-bind="pricing" />
          <div class="page-header__links ds-margin-top-24 ds-md-margin-top-48">
            <DsLink
              v-if="headerLinks.documentationLink"
              v-bind="headerLinks.documentationLink"
              :content="headerLinks.documentationLink.title"
              class="page-header__links__link"
              type="button"
              data-j-button-documentation
            />
            <DsLink
              v-if="headerLinks.pricingLink"
              v-bind="headerLinks.pricingLink"
              :content="headerLinks.pricingLink.title"
              :icon-right="{ category: 'arrows', name: 'chevron-right-small' }"
              class="ds-margin-top-24 ds-md-margin-top-0 ds-md-margin-left-24"
              data-j-button-pricing
            />
          </div>
        </div>
        <div class="page-header__image-col ds-grid__col ds-grid__col--12 ds-lg-grid__col--5 ds-lg-grid__col--offset-1">
          <div
            class="page-header__image-col__image-wrapper ds-width-full ds-sm-only-full-screen ds-md-only-full-screen"
            :style="computedBackgroundColor"
            data-j-image-box
          >
            <div class="page-header__image-col__image-wrapper__box">
              <img
                class="page-header__image-col__image-wrapper__box__image"
                :src="image.src"
                :alt="image.alt"
                width="140px"
                height="91px"
                data-j-image
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup>
import { DsLink } from 'awds'
const { getBackgroundColor } = usePageUtils()

const opacity15 = 'D9'

const props = defineProps({
  headerContent: {
    type: Object,
    required: true,
    validator: obj => ['link', 'title', 'description'].every(key => key in obj)
  },
  headerLinks: {
    type: Object,
    required: true
  },
  backgroundColor: {
    type: String,
    default: null
  },
  image: {
    type: Object,
    required: true,
    validator: obj => ['src', 'alt'].every(key => key in obj)
  },
  pricing: {
    type: Object,
    required: true
  }
})

const computedBackgroundColor = computed(() => {
  return { backgroundColor: (getBackgroundColor(props.backgroundColor) + opacity15) }
})

</script>

<script>
export default {
  name: 'PaymentMethodPageHeader',
}
</script>

<style lang="scss" scoped>
@import 'awds/foundation-vars.scss';
@import 'awds/foundation-mixins.scss';

.page-header {
  &__grid {
    flex-direction: column-reverse;

    @include screen('large') {
      flex-direction: row;
    }
  }

  &__links {
    align-items: center;
    display: flex;
    flex-direction: column;

    &__link {
      justify-content: center;
      width: 100%;
    }

    @include screen('medium') {
      flex-direction: row;

      &__link {
        justify-content: flex-start;
        width: auto;
      }
    }
  }

  &__image-col {
    background-color: $color-white;

    &__image-wrapper {
      align-items: center;
      display: flex;
      height: 280px;
      justify-content: center;

      @include screen('medium') {
        height: 460px;
      }

      @include screen('large') {
        height: 100%;
      }

      &--default-background {
        background-color: #{$color-grey-500}D9;
      }

      &__box {
        height: 78px;
        width: 120px;

        &__image {
          height: 100%;
          width: 100%;
        }
      }
    }
  }
}
</style>
